import { Suspense, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppRouter from '@/routes/router';
import { WebSocketProvider } from './context/WebSocketContext';
import AppProvidersWrapper from './components/wrappers/AppProvidersWrapper';
import LanguageWrapper from './components/wrappers/LanguageWrapper';
import { LayoutProvider } from './context/useLayoutContext';
import ErrorBoundary from './components/ErrorBoundary';

import '@/assets/scss/app.scss';

// configureFakeBackend(); // This can be removed if not needed

const App = () => {
  useEffect(() => {
    document.title = "Archipel de l'alignement";
  }, []);

  return (
    <ErrorBoundary>
      <Suspense fallback={<div>Loading...</div>}>
        <AppProvidersWrapper>
          <WebSocketProvider>
            <LayoutProvider>
              <Routes>
                {/* Route for language-specific paths */}
                <Route path="/:lang/*" element={<LanguageWrapper><AppRouter /></LanguageWrapper>} />

                {/* Fallback route to redirect to a default language */}
                <Route path="*" element={<Navigate to="/fr/dashboard" replace />} />
              </Routes>
            </LayoutProvider>
          </WebSocketProvider>
        </AppProvidersWrapper>
      </Suspense>
    </ErrorBoundary>
  );
};

export default App;